import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AppShell } from "@/components/AppShell";
import ActivityPage from "@/pages/ActivityPage";
import AutomationsPage from "@/pages/AutomationsPage";
import InboxPage from "@/pages/InboxPage";
import SettingsPage from "@/pages/NoCRMSettingsPage";
import QuoteSettingsPage from "@/pages/QuoteSettingsPage";
import QuoteReviewPage from "@/pages/QuoteCorrectionPage";
import GmailSettingsPage from "@/pages/GmailSettingsPage";
import StatsPage from "@/pages/StatsPage";
import ShortReportPage from "@/pages/ShortReportPage";
import AgentStatsPage from "@/pages/AgentStatsPage";
import CockpitPage from "@/pages/CockpitPage";
import CallSessionPage from "@/pages/CallSessionPage";
import DebriefPage from "@/pages/DebriefPage";
import FilePrepPage from "@/pages/FilePrepPage";
import RecyclePage from "@/pages/RecyclePage";
import LeadRecyclePage from "@/pages/LeadRecyclePage";
import MigrationPage from "@/pages/MigrationPage";
import ProspectFilesPage from "@/pages/ProspectFilesPage";
import HomePage from "@/pages/HomePage";
import SendQueuePage from "@/pages/SendQueuePage";
import RelancePathPage from "@/pages/RelancePathPage";
import SitePage from "@/pages/SitePage";
import SegmentPage from "@/pages/SegmentPage";
import CabinetPage from "@/pages/CabinetPage";
import LegalPage from "@/pages/LegalPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ReviewsAdminPage from "@/pages/ReviewsAdminPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ClientPage from "@/pages/ClientPage";
import ClientsPage from "@/pages/ClientsPage";
import PipelinePage from "@/pages/PipelinePage";
import PipelineSettingsPage from "@/pages/PipelineSettingsPage";
import RingoverSettingsPage from "@/pages/RingoverSettingsPage";
import ProjectPage from "@/pages/ProjectPage";
import InvitationPage from "@/pages/InvitationPage";
import StepRulesPage from "@/pages/StepRulesPage";
import RepliesPage from "@/pages/RepliesPage";
import LoginPage from "@/pages/LoginPage";
import UsersPage from "@/pages/UsersPage";
import ContactRequestsPage from "@/pages/ContactRequestsPage";
import { AuthProvider, RequireAuth, useAuth } from "@/auth";
import { canSee, homeFor } from "@/permissions";
import "@/App.css";
import "@/theme.css";
import "@/themes";

function ShellRoutes({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!canSee(user, location.pathname)) return <Navigate to={homeFor(user)} replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <BrowserRouter>
     <AuthProvider>
      <Routes>
        <Route path="/" element={<SitePage />} />
        <Route path="/pompe-a-chaleur/:slug" element={<SegmentPage />} />
        <Route path="/mentions-legales" element={<LegalPage />} />
        <Route path="/le-cabinet" element={<CabinetPage />} />
        <Route path="/politique-de-confidentialite" element={<PrivacyPage />} />
        <Route path="/admin" element={<LoginPage />} />
        <Route path="/invitation/:token" element={<InvitationPage />} />
        <Route path="/rapport-agents" element={<main className="shared-report" data-testid="shared-report"><AgentStatsPage shared /></main>} />
        <Route path="/r/:code" element={<main className="shared-report" data-testid="shared-report"><ShortReportPage /></main>} />
        <Route path="*" element={
     <RequireAuth>
      <ShellRoutes>
        <Routes>
          <Route path="/accueil" element={<HomePage />} />
          <Route path="/utilisateurs" element={<UsersPage />} />
          <Route path="/demandes" element={<ContactRequestsPage />} />
          <Route path="/avis-google" element={<ReviewsAdminPage />} />
          <Route path="/automatisation-etapes" element={<StepRulesPage />} />
          <Route path="/pipeline" element={<PipelinePage />} />
          <Route path="/projets" element={<ProjectsPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/clients/:id" element={<ClientPage />} />
          <Route path="/projets/:id" element={<ProjectPage />} />
          <Route path="/activite" element={<ActivityPage />} />
          <Route path="/enrichir" element={<Navigate to="/accueil" replace />} />
          <Route path="/parametres" element={<SettingsPage />} />
          <Route path="/parametres-pipeline" element={<PipelineSettingsPage />} />
          <Route path="/ringover" element={<RingoverSettingsPage />} />
          <Route path="/transfert-nocrm" element={<MigrationPage />} />
          <Route path="/devis" element={<QuoteSettingsPage />} />
          <Route path="/devis/validation" element={<QuoteReviewPage />} />
          <Route path="/automatisations" element={<AutomationsPage />} />
          <Route path="/reponses" element={<RepliesPage />} />
          <Route path="/gmail" element={<GmailSettingsPage />} />
          <Route path="/statistiques" element={<StatsPage />} />
          <Route path="/statistiques-agents" element={<AgentStatsPage />} />
          <Route path="/cockpit" element={<CockpitPage />} />
          <Route path="/session-appels/:id" element={<CallSessionPage />} />
          <Route path="/debrief" element={<DebriefPage />} />
          <Route path="/preparer-fichier" element={<FilePrepPage />} />
          <Route path="/recyclage" element={<RecyclePage />} />
          <Route path="/recyclage-leads" element={<LeadRecyclePage />} />
          <Route path="/fichiers-lobstr" element={<ProspectFilesPage />} />
          <Route path="/envois" element={<SendQueuePage />} />
          <Route path="/parcours" element={<RelancePathPage />} />
          <Route path="*" element={<Navigate to="/accueil" replace />} />
        </Routes>
      </ShellRoutes>
     </RequireAuth>
        } />
      </Routes>
      <Toaster position="bottom-right" richColors />
     </AuthProvider>
    </BrowserRouter>
  );
}
